import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import {
	STOCK_DETAIL_METRICS,
	STOCK_DETAIL_SORT_COLUMNS,
} from "@/features/raporty-dashboard/api/dashboard-api";
import { excludedIdfirmsSearchSchema } from "@/features/raporty-dashboard/lib/dashboard-pharmacies";
import { StockDetailPage } from "@/features/raporty-dashboard/StockDetailPage";
import { ensureElementVisible } from "@/lib/route-guards";

const isoDate = z
	.string()
	.regex(/^\d{4}-\d{2}-\d{2}$/)
	.optional();

/**
 * Stan szczegółu w typowanym URL-u. `metric` to STABILNY enum (nie polska
 * etykieta — copy się zmienia, zapisane linki nie mogą), a `dataAsOf` jest
 * jedynie przeniesionym dniem kafla: backend go WERYFIKUJE względem własnego
 * `MAX(snapshot_date)` i odrzuca niezgodność (422 `STOCK_SNAPSHOT_STALE`).
 *
 * `back` niesie opakowany search dashboardu, żeby powrót przywrócił WSZYSTKIE
 * jego filtry (także te, których szczegół nie używa: okres, multiselect
 * kategorii). Jest sanityzowany przy odczycie i nigdy nie steruje ścieżką.
 */
const searchSchema = z.object({
	metric: z.enum(STOCK_DETAIL_METRICS),
	scope: z.string().optional(),
	excludedIdfirms: excludedIdfirmsSearchSchema,
	category: z.string().optional(),
	kosmetyk: z.boolean().optional(),
	natubay: z.boolean().optional(),
	rodzaj: z.enum(["ALL", "OTC", "RX", "RX100", "BD"]).optional(),
	dataAsOf: isoDate,
	q: z.string().max(100).optional(),
	sortBy: z.enum(STOCK_DETAIL_SORT_COLUMNS).optional().catch(undefined),
	sortDir: z.enum(["asc", "desc"]).optional().catch(undefined),
	offset: z.number().int().min(0).optional().catch(undefined),
	back: z.string().max(10000).optional().catch(undefined),
});

export type DashboardStockDetailSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/raporty/dashboard-magazyn-szczegol")({
	beforeLoad: async ({ context, location }) => {
		// Szczegół jest częścią dashboardu i nie ma własnej pozycji w menu —
		// bramkuje go TEN SAM element widoczności co stronę, z której się wchodzi.
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.dashboard-analityczny",
			location.pathname,
		);
	},
	component: StockDetailPage,
	validateSearch: (search: Record<string, unknown>): DashboardStockDetailSearch =>
		searchSchema.parse(search),
});
